import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "dots-blur-11", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 11 11", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "currentColor", fillRule: "evenodd" },
        React.createElement("circle", { cx: 4, cy: 4, r: 1 }),
        React.createElement("circle", { cx: 7, cy: 4, r: 1 }),
        React.createElement("circle", { cx: 7, cy: 7, r: 1 }),
        React.createElement("circle", { cx: 4, cy: 7, r: 1 }),
        React.createElement("circle", { cx: 1.25, cy: 7, r: 1, opacity: 0.7 }),
        React.createElement("circle", { cx: 1.25, cy: 4, r: 1, opacity: 0.7 }),
        React.createElement("circle", { cx: 9.75, cy: 4, r: 1, opacity: 0.7 }),
        React.createElement("circle", { cx: 9.75, cy: 7, r: 1, opacity: 0.7 }),
        React.createElement("circle", { cx: 7, cy: 9.75, r: 1, opacity: 0.7 }),
        React.createElement("circle", { cx: 4, cy: 9.75, r: 1, opacity: 0.7 }),
        React.createElement("circle", { cx: 4, cy: 1.25, r: 1, opacity: 0.7 }),
        React.createElement("circle", { cx: 7, cy: 1.25, r: 1, opacity: 0.7 }),
        React.createElement("circle", { cx: 9.75, cy: 1.25, r: 1, opacity: 0.5 }),
        React.createElement("circle", { cx: 9.75, cy: 9.75, r: 1, opacity: 0.5 }),
        React.createElement("circle", { cx: 1.25, cy: 1.25, r: 1, opacity: 0.5 }),
        React.createElement("circle", { cx: 1.25, cy: 9.75, r: 1, opacity: 0.5 })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
